/* GiveMeMoneyAPI - index.ts
*
*  @description: index for PaymentRequestButton
*
*  History:
*   *TBN 09/17 - Created
*/

export { PaymentRequestButton } from './PaymentRequestButton';
export { PaymentRequestActions } from './PaymentRequestButton';


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/modules/PaymentRequestButton/index.ts